// @flow
import { Text } from "./slices/Text";
import { Quote } from "./slices/Quote";
import { ImageGallery } from "./slices/ImageGallery";
import { EmailSignUp } from "./slices/EmailSignUp";
import { MaxThreeColTable } from "./slices/MaxThreeColTable";
import { PostcodeCTA } from "./slices/PostcodeCTA";
import { BannerCTA } from "./slices/BannerCTA";

const components = {
  quote: Quote,
  text: Text,
  image_gallery: ImageGallery,
  email_sign_up: EmailSignUp,
  max_three_col_table: MaxThreeColTable,
  postcode_cta: PostcodeCTA,
  banner_cta: BannerCTA,
};

type Props = {
  children: PrismicSlice,
};

const createComponentFromSlice = ({
  slice_type: type,
  primary: props,
  items,
}) => {
  const Component = components[type];

  if (!Component) {
    return null;
  }
  return <Component {...props} repeat={items} />;
};

const Slice = ({ children }: Props) => createComponentFromSlice(children);

export { Slice };
